export const LOGIN = '/login';
export const LOGOUT = '/logout';
export const REGISTER = '/register';
export const VALIDATE = '/account-confirmation';
export const USER_SETTINGS = '/user-settings';
export const HOME = '/';
export const INDEX = '/index';
export const HAULCHECK = '/haulcheck';
